export function append(key: string, obj: Partial<import('@ok/video-player').IOneVideoPlayerCallbacks>) {
    let cbs = window.OK.OneVideoPlayerCallback;
    if (cbs){
        cbs[key] = obj;
    } else {
        window.OK.OneVideoPlayerCallback = {};
        window.OK.OneVideoPlayerCallback[key] = obj;
    }
}

export function getOneVideoPlayerCallbacksStore(){
    return window.OK.OneVideoPlayerCallback;
}


